export default "__VITE_ASSET__eX19sPZV__"